/**
 * Shop sidebar navigation (murals / canvas / wallpaper).
 *
 * When you land on a collection sub-category page, find the matching link in the
 * sidebar, mark it active, and open every dropdown that contains it (plus the
 * "See More" section when the category lives there) so the active category tree
 * stays expanded rather than collapsed.
 *
 * The collapse/expand mechanics themselves (the `[data-toggle="collapse"]` click
 * handler, the `.collapse.show` / `.smooth-slide-container.show` styles and the
 * `li.open` toggler icon) are defined in global.js and base.css; this file only
 * sets the initial open/active state to reflect the current URL.
 */
(function () {
  const highlightActiveSidebarCategory = () => {
    const nav = document.getElementById('shopNavigation');
    if (!nav) return;

    const currentPath = window.location.pathname.replace(/\/+$/, '');
    // Ignore the bare collection landing page (e.g. /collections/murals): it maps
    // to no specific sub-category and several catch-all links point at it.
    if (!currentPath || /^\/collections\/[^/]+$/.test(currentPath)) return;

    const matches = Array.from(nav.querySelectorAll('a[href]')).filter(link => {
      const href = (link.getAttribute('href') || '').split(/[?#]/)[0].replace(/\/+$/, '');
      return href && href === currentPath;
    });
    if (!matches.length) return;

    // Suppress the collapse/slide animations for this initial state so the tree
    // appears already-open instead of sliding open on every page load.
    nav.classList.add('no-collapse-anim');

    matches.forEach(link => {
      link.classList.add('is-active-category');

      // If the active link is itself a parent category, open its own submenu.
      const li = link.closest('li');
      if (li) {
        const ownSubmenu = li.querySelector(':scope > ul.collapse');
        if (ownSubmenu) {
          ownSubmenu.classList.add('show');
          li.classList.add('open');
        }
      }

      // Walk up and open every ancestor dropdown + the "See More" container.
      let el = link.parentElement;
      while (el && el !== nav) {
        if (el.matches('ul.collapse')) {
          el.classList.add('show');
          const parentLi = el.closest('li');
          if (parentLi) parentLi.classList.add('open');
        }
        if (el.classList.contains('smooth-slide-container')) {
          el.classList.add('show');
        }
        el = el.parentElement;
      }
    });

    // Keep the "See More"/"Hide" triggers in sync with the now-open section.
    const seeMore = document.getElementById('old-categories-wrap');
    if (seeMore && seeMore.classList.contains('show')) {
      document.querySelectorAll('[data-toggle="collapse"][data-target="#old-categories-wrap"]').forEach(trigger => {
        trigger.classList.add('is-expanded');
      });
    }

    // Re-enable animations once the browser has painted the initial open state.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => nav.classList.remove('no-collapse-anim'));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', highlightActiveSidebarCategory);
  } else {
    highlightActiveSidebarCategory();
  }

  // Keep each parent <li>'s `.open` state (which flips the toggler chevron between
  // down/up) in sync when a category toggler is clicked. The shared collapse()
  // handler in global.js toggles the submenu's `.show` but not `li.open`, so
  // without this the chevron would stay "closed" on manually-opened categories.
  // Registered on `window` after global.js's handler, so by the time this runs
  // the submenu's `.show` already reflects the new open/closed state.
  window.addEventListener('click', (ev) => {
    const toggler = ev.target.closest && ev.target.closest('.category-toggler');
    if (!toggler) return;
    const nav = document.getElementById('shopNavigation');
    if (!nav || !nav.contains(toggler)) return;
    const li = toggler.closest('li');
    const targetSelector = toggler.getAttribute('data-target');
    const target = targetSelector ? document.querySelector(targetSelector) : null;
    if (li && target) {
      li.classList.toggle('open', target.classList.contains('show'));
    }
  }, false);
})();
